import { IFormValues } from './interfaces';

export const DEFAULT_VALUES: IFormValues = {
  uuid: null,
  role: null,
  last_name: '',
  first_name: '',
  middle_name: '',
};
